import { twMerge } from "tailwind-merge";

import { IconProps } from "~/common/utils";

export const WrenchIcon = ({ className, ...props }: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={twMerge(className)}
      {...props}
    >
      <path
        d="M8.92631 6.21602L8.14575 5.43547C7.36031 4.65002 7.63986 3.33203 8.75065 3.33203C10.2464 3.33203 11.6006 3.93831 12.5808 4.91854C13.561 5.89876 14.1673 7.25293 14.1673 8.7487C14.1673 9.02368 14.1468 9.29387 14.1073 9.55783C14.0103 10.2057 14.1445 10.8931 14.6135 11.3504L16.2921 12.987C16.9571 13.6354 16.9638 14.7022 16.3071 15.3589L15.3458 16.3202C14.695 16.9711 13.6397 16.9711 12.9888 16.3202L11.2731 14.6045C10.821 14.1524 10.1521 14.0214 9.51905 14.1113C9.26804 14.1469 9.0115 14.1654 8.75065 14.1654C7.25488 14.1654 5.90071 13.5591 4.92049 12.5789C3.94027 11.5986 3.33398 10.2445 3.33398 8.7487C3.33398 7.63791 4.65197 7.35835 5.43742 8.1438L6.21797 8.92435C6.86885 9.57523 7.92412 9.57523 8.575 8.92435L8.92631 8.57304C9.57718 7.92217 9.57718 6.8669 8.92631 6.21602Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
